import { FilterConfigPassive } from '@/types/filter';
import { getComparisonPeriodOptions } from '../../utils';
import { AppRoutes } from '@/utils';
import { Period, TimePeriod } from '@/types/date';
import dayjs from 'dayjs';
import { getPeriodUntilDate, getPreviousPeriod } from '@/utils/date';

const comparisonPeriodFilter: FilterConfigPassive<Period> = {
  label: 'global.filters.formControls.comparisonPeriodLabel',
  options: getComparisonPeriodOptions(),
  defaultValue: getPreviousPeriod(getPeriodUntilDate(dayjs(), TimePeriod.YTD)),
  type: 'dropdown',
  disabled: ({ contexts: { location } }) => {
    const disabledRoutesForDate = [AppRoutes.PARTNERSCORE, AppRoutes.CESSCORE, AppRoutes.CSATSCORE, AppRoutes.NPSSCORE];
    return disabledRoutesForDate.includes(location.pathname as AppRoutes) ? true : false;
  },
};

export default comparisonPeriodFilter;
